import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'
import type { Tone } from '@/lib/status'

const TONES: Record<Tone, string> = {
  neutral: 'bg-neutral-subtle text-fg-muted border-neutral-border',
  info: 'bg-info-subtle text-info border-info-border',
  success: 'bg-success-subtle text-success border-success-border',
  warning: 'bg-warning-subtle text-warning border-warning-border',
  danger: 'bg-danger-subtle text-danger border-danger-border',
  violet: 'bg-violet-subtle text-violet border-violet-border',
}

export interface BadgeProps {
  tone?: Tone
  children: ReactNode
  icon?: ReactNode
  className?: string
  size?: 'sm' | 'md'
}

export function Badge({ tone = 'neutral', children, icon, className, size = 'md' }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full border font-medium whitespace-nowrap',
        size === 'sm' ? 'px-1.5 py-0 text-2xs' : 'px-2 py-0.5 text-xs',
        TONES[tone],
        className,
      )}
    >
      {icon}
      {children}
    </span>
  )
}

/** A small count pill, e.g. beside a facet tab. */
export function CountBadge({ count, active }: { count: number; active?: boolean }) {
  return (
    <span
      className={cn(
        'tabular ml-1.5 rounded-full px-1.5 py-0.5 text-2xs font-medium',
        active ? 'bg-accent text-accent-fg' : 'bg-surface-sunken text-fg-subtle',
      )}
    >
      {count}
    </span>
  )
}
